import { Box, Button, Icon, useToast } from "@chakra-ui/react";
import { Resolver, UseFormRegister, useForm } from "react-hook-form";
import { MdCheck } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Paper } from "../Paper";
import { UpsertFormSkeleton } from "./Skeleton";

interface Props<T extends { [x: string]: any }> {
  [x: string]: any;
  isLoading: boolean;
  defaultValues?: { [x: string]: any };
  handleSave: (values: T) => Promise<any>;
  resolver: Resolver<T>;
  children: (
    register: UseFormRegister<T>,
    errors: any,
    control?: any,
    watch?: any,
    setValue?: any,
  ) => React.ReactElement;
}

export function UpsertForm<T extends { [x: string]: any }>({
  isLoading,
  defaultValues,
  handleSave,
  resolver,
  children,
  ...props
}: Props<T>) {
  
  const navigate = useNavigate();
  
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
    control,
    watch,
    setValue
  } = useForm<T>({
    resolver,
    values: defaultValues as T,
  });

  function handleCancel() {
    navigate("..");
  }

  const toast = useToast()

  async function _handleSave(data: T) {
    try {
      await handleSave(data);
    } catch (e: any) {
      toast({
        description: JSON.stringify(e?.response?.data, null, 2),
        title: 'Erro',
        status: 'error'
      })
    }
  }

  return (
    <Paper as="form" {...props} onSubmit={handleSubmit(_handleSave)} px={7} py={4}  >
      {
        isLoading ? <UpsertFormSkeleton /> : children(register, errors, control, watch, setValue)
      }
      <Box gap={6} pt={3} display="flex" justifyContent="space-between">
        <Button colorScheme="red" variant={'ghost'} size={'sm'} onClick={handleCancel}>
          Cancelar
        </Button>
        <Button colorScheme="green" type="submit" size={'sm'} isLoading={isSubmitting}>
          <Icon as={MdCheck} mr={3} />
          Salvar
        </Button>
      </Box>
    </Paper>
  );
}
